<div class="flex flex-col items-center justify-center space-y-4">
  <mat-spinner></mat-spinner>
  <span class="text-center text-2xl">{{
    'Ti stiamo connettendo al portale' | siaTranslate
  }}</span>
</div>
